import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "version" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "default-content" }

export function render(_ctx, _cache) {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_el_main = _resolveComponent("el-main")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onLogoClick && _ctx.onLogoClick(...args)))
          }, [
            _createVNode(_component_el_image, { src: "/img/ddg-logo-128.png" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('logo-line' + ((_ctx.windowWidth < 768) ? '-mobile' : ''))
          }, _cache[1] || (_cache[1] = [
            _createTextVNode(" MC.health"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("Prüfungsplattform ")
          ]), 2),
          _createElementVNode("div", _hoisted_2, " V. " + _toDisplayString(_ctx.environmentVersion), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_main, { class: "rounded-content" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "reset-form" }, " An dieser Stelle können Sie Ihr Passwort zurücksetzen lassen. ", -1)
          ])),
          _: 1
        })
      ])
    ])
  ], 64))
}